import { Tag } from "./tag";

/** Props Interface */
interface BooleanTagProps {
	value: boolean;
}

export function BooleanTag({ value }: BooleanTagProps) {
	return (
		<Tag
			variant="plain"
			color={value ? "emerald" : "red"}
		>
			{value ? "Yes" : "No"}
		</Tag>
	);
}
